import { TokenFlowSchema } from './chunk-LQ53YLJL.js';

// src/transpose/types.ts
var NATIVE_COIN_FLOW_KINDS = /* @__PURE__ */ new Set([
  "native",
  "internal",
  "closure"
]);
var NON_FUNGIBLE_FLOW_KINDS = /* @__PURE__ */ new Set([
  "erc721",
  "erc1155"
]);
var TOKEN_FLOW_KINDS = new Set(
  TokenFlowSchema.shape.kind.options.filter((kind) => !NATIVE_COIN_FLOW_KINDS.has(kind))
);

export { NATIVE_COIN_FLOW_KINDS, NON_FUNGIBLE_FLOW_KINDS, TOKEN_FLOW_KINDS };
//# sourceMappingURL=chunk-OKU57CF6.js.map
//# sourceMappingURL=chunk-OKU57CF6.js.map